import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { GenerateCodeResponse, VerifyCodeResponse, VerificationCodeRequest } from '../../../types/phoneVerification';

export const generatePhoneVerificationCodeRequest = action(
  'GENERATE_PHONE_VERIFICATION_CODE_REQUEST',
  withPayload<string>(),
);

export const generatePhoneVerificationCodeSuccess = action(
  'GENERATE_PHONE_VERIFICATION_CODE_Success',
  withPayload<GenerateCodeResponse>(),
);

export const generatePhoneVerificationCodeFail = action(
  'GENERATE_PHONE_VERIFICATION_CODE_FAIL',
  withoutPayload,
);

export const generatePhoneVerificationClear = action(
  'GENERATE_PHONE_VERIFICATION_CODE_CLEAR',
  withoutPayload,
);

export const verifyPhoneRequest = action(
  'VERIFY_PHONE_REQUEST',
  withPayload<VerificationCodeRequest>(),
);

export const verifyPhoneSuccess = action(
  'VERIFY_PHONE_SUCCESS',
  withPayload<VerifyCodeResponse>(),
);

export const verifyPhoneFail = action(
  'VERIFY_PHONE_FAIL',
  withoutPayload,
);

export const verifyPhoneClear = action(
  'VERIFY_PHONE_CLEAR',
  withoutPayload,
);

export const resetVerificationCodeCurrentAttempt = action(
  'RESET_VERIFICATION_CODE_CURRENT_ATTEMPT',
  withoutPayload,
)
